module.exports = __webpack_public_path__ + "static/img/10010 (4).89782a9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10010 (4).webp
// module id = LJaw
// module chunks = 14